/**
 * Read by screen readers, invisible on screen, and 1 px so it adds no scroll area.
 * Write sizes as '1px' strings: in MUI `sx`, a bare `1` means 100%.
 */
export const visuallyHiddenSx = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
    border: 0,
} as const;
